import {isUndefined} from "./object";

// Fires an event on an element.
// Listen for these events in the standard way:
// ```
// theElement.addEventListener('theEventName', (event)=>{ console.log(event.memo) });
// ```
// The memo is accessible on the event object in the listener function.
export function fireElementEvent(element, eventName, memo, bubble) {
    if (isUndefined(bubble)) bubble = true;
    let event = new CustomEvent(eventName, {bubbles: bubble, detail: (memo || {})});
    element.dispatchEvent(event);
    return event;
}
